module.exports = __webpack_public_path__ + "img/曲阜天博.png";